export const litiumBaseUrl = process.env.LITIUM_URL || 'b2b.vinga.dev';
